module.exports = __webpack_public_path__ + "static/media/footer.15116c27.png";